import CardContent from '@mui/material/CardContent'
import { count, getCanonicalSlug, isDefined, lowestPrice, money, productLink } from '@components/config/helpers'
import dayjs from 'dayjs'
import P, { Span } from '@components/Components/Reusables/Typography/P'
import PrimaryTable from '@components/Components/Reusables/Table/PrimaryTable'

const ProductCardPriceBreaks = (props) => {
    const {
        long_term_product,
        price_breaks,
        new_price_breaks,
        product
    } = props;

    const product_price = product?.price_breaks && count(product.price_breaks) > 0 ? lowestPrice(product, false) : product.product_price;
    const urlLink = getCanonicalSlug({ canonical_category_slug: product.canonical_category_slug, section_slug: product.section_slug });

    return (
        <>
            <P className="uppercase m-0 p-0 mb-1" as="h5" color="#333">{new_price_breaks?.headers?.length > 1 ? 'Quantity ' : ''}Discounts</P>
            <CardContent
                itemProp="offers" itemScope itemType="https://schema.org/Offer"
                className='w-100 p-0'
                sx={{
                    borderRadius: 0.5,
                    mt: {
                        xs: 2,
                        md: 0
                    }
                }}
            >
                <meta itemProp="priceCurrency" content="GBP" />
                <meta itemProp="url" content={productLink(urlLink, product.product_slug, long_term_product)} />
                <meta itemProp="description" content={product.meta_description} />
                <meta itemProp="priceValidUntil" content={dayjs().add(1, 'year').format('YYYY-MM-DD')} />

                {long_term_product != true && (
                    <>
                        <meta itemProp='price' content={product_price} />

                        {new_price_breaks?.length && new_price_breaks.length == 0 ? (
                            <>
                                <PrimaryTable
                                    color="secondary"

                                >
                                    <PrimaryTable.Head>
                                        <PrimaryTable.Row color="secondary" opacity={0}>
                                            <PrimaryTable.Cell
                                                className="p-2"
                                                sx={{
                                                    borderRight: '1px solid lightgrey !important'
                                                }}
                                                as="th"
                                            >
                                                Qty
                                            </PrimaryTable.Cell>
                                            <PrimaryTable.Cell className="text-end p-2" as="th">Price</PrimaryTable.Cell>
                                        </PrimaryTable.Row>
                                    </PrimaryTable.Head>

                                    <PrimaryTable.Body>
                                        {price_breaks.map((price_break, idx) => (
                                            <PrimaryTable.Row
                                                key={price_break.product_price_break_id + '_' + idx}
                                                sx={{
                                                    '> td': {
                                                        padding: '8px !important'
                                                    }
                                                }}
                                                swapEven last={false} color="secondary">
                                                <PrimaryTable.Cell
                                                    className="light-border"
                                                    sx={{
                                                        borderRight: '1px solid lightgrey !important'
                                                    }}
                                                >
                                                    {price_break.min_qty}{price_break.max_qty > 500 ? '+' : ' -' + ' ' + price_break.max_qty}
                                                </PrimaryTable.Cell>
                                                <PrimaryTable.Cell className="text-end">
                                                    &nbsp;&pound;{price_break.price}
                                                    {price_break.on_offer == 'yes' ? money(price_break.price - ((price_break.special_discount * price_break.price) / 100)) : ''}
                                                </PrimaryTable.Cell>
                                            </PrimaryTable.Row>
                                        ))}
                                    </PrimaryTable.Body>
                                </PrimaryTable>
                            </>
                        ) : (
                            <>
                                <PrimaryTable
                                    color="secondary"
                                    className="border-none"
                                    sx={{
                                        'thead > tr > th, tbody > tr > td': {
                                            fontSize: {
                                                xs: '12px !important',
                                                md: '11px !important'
                                            }
                                        }
                                    }}
                                >
                                    <PrimaryTable.Head className="border-none">
                                        <PrimaryTable.Row
                                            color="secondary"
                                            className="border-none"
                                            opacity={0}
                                            sx={{
                                                '> th': {
                                                    padding: '1px !important',
                                                    paddingRight: '4px !important'
                                                }
                                            }}
                                        >
                                            <PrimaryTable.Cell as="th" width="20%" className='text-start fw-bold border-none'></PrimaryTable.Cell>
                                            {new_price_breaks.headers.map((header, idx) => (
                                                <PrimaryTable.Cell
                                                    key={header + "_" + idx}
                                                    className="text-start fw-bold border-none"
                                                    as="th"
                                                    width="20%"
                                                >
                                                    {new_price_breaks.headers.length > 1 ? (
                                                        <>
                                                            {header.min}{header.max > 9999 ? '+' : `${header.max == '' ? '' : `-${header.max}`}`}
                                                        </>
                                                    ) : null}
                                                </PrimaryTable.Cell>
                                            ))}
                                        </PrimaryTable.Row>
                                    </PrimaryTable.Head>

                                    <PrimaryTable.Body>
                                        {new_price_breaks.rows.map((row, idx) => (
                                            <PrimaryTable.Row
                                                swapEven last={false} color="secondary"
                                                key={idx}
                                                sx={{
                                                    '> td': {
                                                        padding: '4px !important'
                                                    }
                                                }}
                                            >
                                                <PrimaryTable.Cell
                                                >
                                                    {row.weeks == 1 ? '1-7 days' : `${new_price_breaks.rows.length - 1 == idx ? row.min_weeks + '+' : row?.min_weeks && row?.max_weeks && row.min_weeks != row.max_weeks ? row.min_weeks + '-' + row.max_weeks : row.weeks} weeks`}
                                                </PrimaryTable.Cell>

                                                {
                                                    row.price_breaks.map((price_break_cost, idx) => (
                                                        <PrimaryTable.Cell
                                                            key={`${price_break_cost}_${idx}`}
                                                            className="text-start"
                                                        >
                                                            {money(price_break_cost)}
                                                        </PrimaryTable.Cell>
                                                    ))
                                                }
                                            </PrimaryTable.Row>
                                        ))}
                                    </PrimaryTable.Body>

                                </PrimaryTable>
                            </>
                        )}
                    </>
                )}

                <Span itemProp='seller' itemScope itemType='https://schema.org/Organisation'>
                    <Span itemProp="name" className="d-none">{process.env.brand.brand_name}</Span>
                </Span>
                <link itemProp='availability' href="https://schema.org/InStock" />
            </CardContent>
        </>
    )
}

export default ProductCardPriceBreaks